module.exports = __webpack_public_path__ + "static/img/nav_fix1.6b3adbe4.png";